import { rgba } from 'polished'
import { memo } from 'react'

const DefaultChartTooltipContent: FC = ({ children }) => {
  return (
    <Box
      $backgroundColor={rgba(255, 255, 255, 0.6)}
      $borderColor='grayscale.300'
      $borderRadius='md'
      $borderWidth={1}
      $p='md'
      $pointerEvents='none'
    >
      {children}
    </Box>
  )
}

export default memo(DefaultChartTooltipContent)
